import { Component, Input } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
    selector: 'ngx-checkbox',
    styleUrls: ['./checkbox.component.scss'],
    templateUrl: './checkbox.component.html',
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class CheckboxComponent {
  @Input() name: string;
  @Input() value: boolean;
  @Input() disabled: boolean;
  @Input() controlName: string;
}
